import * as martinez from 'martinez-polygon-clipping';

var mapUtil = {
    getBounds: function(map) {
        var mapBounds = map.getBounds(),
            boundsArray = [];
        for (var i in mapBounds) {
            if (!mapBounds.hasOwnProperty(i)) {
                continue; 
            }
            for (var j in mapBounds[i]) {
                if (!mapBounds[i].hasOwnProperty(j)) {
                    continue; 
                }
                if (typeof mapBounds[i][j] === 'number') {
                    boundsArray.push(mapBounds[i][j]);
                }
            }
        }
        boundsArray.sort(function(a, b) {
            return a - b;
        });
        return boundsArray;
    },
    getMapBounds: function(map) {
        var boundsArray = mapUtil.getBounds(map);
        return {
            nwLat: boundsArray[3],
            nwLng: boundsArray[0],
            seLat: boundsArray[2],
            seLng: boundsArray[1]
        };
    },
    getFormatBounds: function(map) {
        var bounds = mapUtil.getBounds(map);
        return [
            {
                lng: bounds[0],
                lat: bounds[2]
            },
            {
                lng: bounds[1],
                lat: bounds[2]
            },
            {
                lng: bounds[1],
                lat: bounds[3]
            },
            {
                lng: bounds[0],
                lat: bounds[3]
            }
        ];
    },

    // whether the point is inside the quadrilateral 
    pointInbound: function(x, y, bounds) {
        return (
            x >= bounds[0] && x <= bounds[1] && y >= bounds[2] && y <= bounds[3]
        );
    },

    // whether the point is inside the quadrilateral ， pass parameter as object
    posInbound: function(pos, bounds) {
        return mapUtil.pointInbound(pos.lng, pos.lat, bounds);
    },

    // whether the point is inside the polygon 
    pointInPolygon(point, vs) {
        var x = point.lng,
            y = point.lat;
        var inside = false;
        for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
            var xi = vs[i].lng,
                yi = vs[i].lat;
            var xj = vs[j].lng,
                yj = vs[j].lat;

            var intersect =
                yi > y !== yj > y &&
                x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
            if (intersect) {
                inside = !inside; 
            }
        }
        return inside;
    },
    // whether the point is inside the polygon , or on the vertices of the polygon 
    pointInOrOnPolygon(point, vs) {
        for (var i = 0; i < vs.length; i++) {
            if (point.lng === vs[i].lng && point.lat === vs[i].lat) {
                return true;
            }
        }
        return this.pointInPolygon(point, vs);
    },

    // Calculate the distance between two points 
    distance(p1, p2) {
        return Math.sqrt(
            Math.pow(p1.lat - p2.lat, 2) + Math.pow(p1.lng - p2.lng, 2)
        );
    },

    // Calculate the intersection point of two polygons  vs2 painting borders   vs1  borders of the map 
    intersectionPolygon(vs2, vs1) {
        var geom1 = mapUtil.pathToGeo(vs1),
            geom2 = mapUtil.pathToGeo(vs2);
        var coor = martinez.intersection(geom1.coordinates, geom2.coordinates);
        return mapUtil.geoToPath(coor[0]);
    },

    // format conversion 
    pathToGeo(vs) {
        var geom = {
            type: 'Polygon',
            coordinates: [[]]
        };
        for (var i = 0; i < vs.length; i++) {
            geom.coordinates[0].push([vs[i].lng, vs[i].lat]);
        }
        geom.coordinates[0].push([vs[0].lng, vs[0].lat]);
        return geom;
    },
    // format conversion 
    geoToPath(geo) {
        if (!geo || !geo.length) {
            return [];
        }
        var path = [];
        for (var i = 0; i < geo[0].length - 1; i++) {
            path.push({ lng: geo[0][i][0], lat: geo[0][i][1] });
        }
        return path;
    }
};

export default mapUtil;
